import React, { memo, useState } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space, LoadingContainer } from '@redlink/components/atoms';
import { ChartColorGuid } from '@redlink/components/molecules';
import { useLocale } from '@redlink/assets/locale';
import { ChartBlockContainer } from './chartBlockContainer';
import {
  VictoryLine,
  VictoryChart,
  VictoryTheme,
  VictoryAxis,
  VictoryTooltip,
} from 'victory-native';
import { VictoryVoronoiContainer } from 'victory';
import { useQuery, getUsersWithChartQuery } from '@redlink/services';

export const UserBlock = memo(() => {
  const { dictionary } = useLocale();
  const [periodType, setPeriodType] = useState('lastMonth');

  const {
    loading,
    data: { UsersWithChart: { basicUsersStats = [], proUsersStats = [] } = {} },
  } = useQuery(getUsersWithChartQuery, {
    variables: {
      period: periodType,
    },
  });

  return (
    <ChartBlockContainer
      title={dictionary.usersRegister}
      selectedPeriodTypeKey={periodType}
      onChangePeriodTypeKey={(i) => setPeriodType(i)}
    >
      <LoadingContainer isBusy={loading}>
        <UserChart {...{ basicUsersStats, proUsersStats }} />
        <Space />
      </LoadingContainer>
    </ChartBlockContainer>
  );
});

const UserChart = memo(({ basicUsersStats, proUsersStats }) => {
  const { colors, styles } = useStyle();
  const { dictionary } = useLocale();
  const [width, setWidth] = useState(0);

  const chartColorGuidData = [
    {
      color: colors.yellow2,
      title: dictionary.proAccount,
    },
    {
      color: colors.blue1,
      title: dictionary.basicAccount,
    },
  ];

  return (
    <View
      onLayout={({
        nativeEvent: {
          layout: { width },
        },
      }) => setWidth(width)}
    >
      <VictoryChart
        height={300}
        width={width}
        theme={VictoryTheme.material}
        containerComponent={<VictoryVoronoiContainer voronoiDimension="x" />}
      >
        <VictoryAxis fixLabelOverlap />
        <VictoryAxis dependentAxis tickFormat={(y) => (y % 1 === 0 ? y : '')} />
        <VictoryLine
          style={{ data: { stroke: colors.blue1, strokeWidth: 4 } }}
          data={basicUsersStats.map(({ label: x, value: y }) => ({ x, y }))}
          labels={({ datum }) => datum.y}
          labelComponent={<VictoryTooltip orientation="top" />}
        />
        <VictoryLine
          style={{ data: { stroke: colors.yellow2, strokeWidth: 4 } }}
          data={proUsersStats.map(({ label: x, value: y }) => ({ x, y }))}
          labels={({ datum }) => datum.y}
          labelComponent={<VictoryTooltip orientation="top" />}
        />
      </VictoryChart>
      <ChartColorGuid
        data={chartColorGuidData}
        style={styles.colorGuidContainer}
      />
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  colorGuidContainer: {
    alignItems: 'flex-end',
    paddingHorizontal: 40,
  },
}));
